<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Project" />
            <ProjectsComp />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import ProjectsComp from '../Projects/ProjectsComp'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'ProjectPage',
    components: {
        NavBar,
        PageTitle,
        ProjectsComp,
        FooterComp,
    }
}
</script>